import { z } from "zod";
import apiRepresentation2dSchema from "./apiRepresentation2dSchema";
import { vector2dSchema } from "../primitivesSchema";

const holeProfilesSchema = z.array(
    z.array(vector2dSchema) // Each element is an array of vectors
  );

const apiShapeRepresentation2dSchema = apiRepresentation2dSchema.extend({
    outerProfile: z.array(z.lazy(() => vector2dSchema)),
    voids: holeProfilesSchema
  });

export default apiShapeRepresentation2dSchema;